import { useCallback, useState } from 'react'
import Table from "../../components/Table/index.jsx";
import { Link } from 'react-router-dom';
import { FaCheckCircle } from "react-icons/fa";
import Header from '../../Header/Header.js';
import SideBar from '../SideBar.js';
import { useQuery } from '@apollo/client';
import { GET_CUSTOMER_TICKET } from '../../graphql/Query/GetSupport.js';
import moment from 'moment';
import { BsBox } from 'react-icons/bs';
import { FiPlus, FiFilter, FiX } from 'react-icons/fi';
import Select from "react-select";
import DateFilter from '../../Common/DateRange.js';
import { getDateRange } from '../../Common/GetDateRange.js';
import { ticketTypeIsueOptionsData } from '../../Common/Constant.js';


const issueCategories = ["Request", "Complaint", "Query"];
export const columns = [

    {
        name: "#",
        selector: (row) => row?.ticketID,
        sortable: true,
        cell: (row) => <span className="font-medium text-blue-600 py-10 text-xs">{row.ticketID}</span>,
    },
    {
        name: "ESCALATION TYPE",
        selector: (row) => row?.issue_type,
        cell: (row) => (
            <div className='flex-col'>
                <div className="flex items-center mb-3 gap-2 font-medium text-xs">
                    {row?.issue_type ? row?.issue_type : "Shipment Issue"}

                </div>
                <p className="inline text-xs border mt-3 border-sky-300 bg-sky-50 rounded-md px-2 py-1">
                    {row?.ticket_type_issue ? row?.ticket_type_issue : "Shipment"}
                </p>
            </div>
        ),
    },
    {
        name: "DETAILS",
        selector: (row) => row?.issue_category,
        cell: (row) => (
            <div className="flex flex-col gap-1 font-medium text-xs">
                {/* Display issue category if it's not in issueCategories */}
                {!issueCategories.includes(row?.issue_category) && (
                    <span>{row?.issue_category}</span>
                )}

                {/* Display AWB Number if available */}
                {(row?.awbNo || row?.order?.awb_number) && <p className='text-blue-600 cursor-pointer' onClick={() => window.open(`/trackcourier?awb=${row?.awbNo || row?.order?.awb_number}`, "_blank")}>AWB: {row?.awbNo || row?.order?.awb_number}</p>}




                {/* Static Status */}
                {(row?.order?.status || row?.status) && <p className="font-semibold text-xs">Status: <span className='font-bold'>{row?.order?.status || row?.status}</span></p>}
            </div>
        )
    },
    {
        name: "DATE",
        sortable: true,
        selector: (row) => (
            <span className="text-xs">
                {moment(row?.createdAt).format("MMM D, YYYY")}
            </span>
        ),
    },
    {
        name: "STATUS",
        selector: (row) => row?.order?.status,
        cell: (row) => {
            const statusColor = {
                "New": "text-gray-500",
                "Assigned": "text-indigo-600",
                "Escalated to operation": "text-blue-500",
                "Pending from seller": "text-yellow-600",
                "Cancelled": "text-red-600",
                "Closed": "text-green-600",
                "Follow Up": "text-purple-600",
                "Re-Opened": "text-yellow-600"
            };

            const status = row?.status?.trim(); // Trim to avoid leading/trailing space issues

            return (
                <span
                    className={`px-3 py-1 text-xs font-semibold ${statusColor[status] || "text-black"}`}
                >
                    <FaCheckCircle className="inline-block mr-1" />
                    {status}
                </span>
            );
        }
    },
    {
        name: "ACTION",
        cell: (row) => (
            <Link
                to='/singleescalation'
                state={{ row }}
                className="border border-gray-300 px-4 py-2 text-black text-xs font-medium rounded-md flex flex-col items-center justify-center hover:bg-gray-100 transition"
            >
                View <br /> Escalation
            </Link>
        ),
        width: "150px",
    }

];


const ViewTableEscalation = () => {
    const [selectedType, setSelectedType] = useState();
    const typeOptionsData = [
        { value: "New", label: "New" },
        { value: "Assigned", label: "Assigned" },
        { value: "Escalated to operation", label: "Escalated to operation" },
        { value: "Pending from seller", label: "Pending from seller" },
        { value: "Cancelled", label: "Cancelled" },
        { value: "Closed", label: "Closed" },
    ];
    const [selectedStatus, setSelectedStatus] = useState();
    const [filter, setFilter] = useState('');
    const [filterOrder, setFilterOrder] = useState('');
    const [awbNumber, setawbNumber] = useState('');
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [showFilters, setShowFilters] = useState(true);
    const [finalRange, setFinalRange] = useState({
        filterType: "Last 30 Days",
        startDate: new Date(),
        endDate: new Date(),
    });
    const { data, loading, refetch } = useQuery(GET_CUSTOMER_TICKET, {
        variables: {
            page: page,
            limit,
            sort: {
                key: "updatedAt",
                type: -1
            },
            filter: filter,
            from: finalRange?.startDate?.toISOString(), // Use updated startDate
            to: finalRange?.endDate?.toISOString(),
            ticketstatus: selectedStatus,
            tickettype: selectedType,
        },
        fetchPolicy: 'cache-and-network'
    });
    // console.log('✌️data --->', data);
    const handlePagination = (page) => {
        // console.log('✌️page --->', page);
        // setLoader(true);
        setPage(page?.selected);
    };


    const handleDateChange = useCallback((range) => {
        setFinalRange(range);
    }, []);
    const handleSearch = (e, awb) => {
        if (awb === 'orderId') {
            setFilterOrder(e.target.value);
            setFilter(e.target.value)
        } else if (awb === 'awbNumber') {
            setFilter(e.target.value);
            setawbNumber(e.target.value)
        } else {
            setFilter(e.target.value);
        }
        setPage(1);

    }

    const resetData = () => {
        setPage(1);
        setFilter("");
        setSelectedType();
        setSelectedStatus();

        setawbNumber("");
        setFilterOrder("");

        const defaultRange = getDateRange("Last 30 Days");
        setFinalRange({
            filterType: "Last 30 Days",
            startDate: defaultRange?.startDate,
            endDate: defaultRange?.endDate,
        });

        handleDateChange({
            filterType: "Last 30 Days",
            startDate: defaultRange?.startDate,
            endDate: defaultRange?.endDate,
        });
    }
    return (
        <div>
            <Header />

            <div className="flex min-h-screen bg-slate-100 overflow-hidden">
                {/* Sidebar */}

                <SideBar />

                {/* Main Content */}
                <div className="flex-1 px-0 py-6 md:p-6 overflow-x-hidden ml-16">
                    <div className="p-6 bg-white border rounded-lg space-y-6">
                        {/* Header Section */}
                        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center">
                            <div className="flex items-center md:space-x-3">
                                <BsBox className="text-2xl hidden md:block text-gray-900 " />
                                <h1 className="text-lg font-bold text-gray-800">
                                    Domestic Shipment Services Across India
                                </h1>
                            </div>
                            <div className="flex flex-wrap items-center justify-center md:justify-start mt-4 lg:mt-0 md:space-x-3 space-y-2 md:space-y-0">
                                <Link
                                    to="/escalations"
                                    className="flex items-center gap-2 text-sm px-4 py-1 bg-gray-800 text-white rounded-lg w-full md:w-auto text-center"
                                >
                                    <FiPlus className="text-lg" />
                                    Create Ticket
                                </Link>

                                <button
                                    onClick={() => setShowFilters(!showFilters)}
                                    className="flex items-center gap-2 text-sm px-4 py-1 bg-slate-700 text-white rounded-lg hover:bg-slate-800 w-full md:w-auto text-center"
                                >
                                    {showFilters ? <FiX className="text-lg" /> : <FiFilter className="text-lg" />}
                                    {showFilters ? "Close" : "Filter"}
                                </button>
                            </div>

                        </div>

                        {/* Filter Section */}
                        {showFilters && (
                            <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
                                {/* Order IDs */}
                                <div className="space-y-2">
                                    <label className="block text-sm font-medium text-gray-700">
                                        Escalation ID:
                                    </label>
                                    <input
                                        type="text"
                                        value={filterOrder}
                                        onChange={(e) => { handleSearch(e, 'orderId') }}                                        // onKeyDown={() => handleSearch('orderId')}
                                        placeholder="Comma Separated"
                                        className="w-full border border-gray-300 rounded-md  px-3 py-1.5 text-gray-700 focus:ring-1 focus:ring-slate-900 focus:outline-none"
                                    />
                                </div>

                                {/* AWB Numbers */}
                                <div className="space-y-2">
                                    <label className="block text-sm font-medium text-gray-700">
                                        AWB No.
                                    </label>
                                    <input
                                        type="text"
                                        value={awbNumber}
                                        onChange={(e) => { setawbNumber(e.target.value); handleSearch(e, 'awbNumber') }}
                                        placeholder="AWB No. (comma-separated)"
                                        className="w-full border border-gray-300 rounded-md  px-3 py-1.5 text-gray-700 focus:ring-1 focus:ring-slate-900 focus:outline-none"
                                    />
                                </div>

                                {/* Type Filter */}

                                <div className="space-y-2">
                                    <label className="block text-sm font-medium text-gray-700">Status:</label>
                                    <Select
                                        options={typeOptionsData}
                                        defaultValue={typeOptionsData[0]}
                                        className="w-full"
                                        value={typeOptionsData.find(option => option?.value === selectedStatus) || null}
                                        onChange={(selectedOption) => setSelectedStatus(selectedOption?.value)}
                                        classNamePrefix="react-select"
                                        styles={{
                                            control: (base, state) => ({
                                                ...base,
                                                borderColor: state.isFocused ? '#d1d5db' : '#d1d5db',
                                                '&:hover': { borderColor: '#64748B' },
                                                boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                                borderRadius: '0.375rem',
                                            }),
                                            singleValue: (base) => ({
                                                ...base,
                                                color: '#000000',
                                                fontSize: '0.875rem',
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                backgroundColor: state.isSelected ? '#cbd5e1' : state.isFocused ? '#cbd5e1' : 'white',
                                                color: state.isSelected ? '#000000' : '#000000',
                                                fontSize: '0.875rem',
                                                '&:hover': {
                                                    backgroundColor: '#cbd5e1',
                                                    color: '#000000',
                                                    fontSize: '0.875rem',
                                                }
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '14px',
                                                color: '#A3AAB5',
                                                fontSize: '0.875rem',
                                            }),
                                        }}
                                    />
                                </div>
                                <div className="space-y-2">
                                    <label className="block text-sm font-medium text-gray-700">Type:</label>
                                    <Select
                                        options={ticketTypeIsueOptionsData}
                                        isSearchable
                                        defaultValue={null}
                                        className="w-full"
                                        value={ticketTypeIsueOptionsData
                                            .flatMap(group => group.options)
                                            .find(option => option.value === selectedType) || null}
                                        onChange={(selectedOption) => setSelectedType(selectedOption?.value)}
                                        classNamePrefix="react-select"
                                        styles={{
                                            menu: (provided) => ({
                                                ...provided,
                                                maxHeight: 300, // Enables scrolling
                                            }),
                                            control: (base, state) => ({
                                                ...base,
                                                borderColor: state.isFocused ? '#d1d5db' : '#d1d5db',
                                                '&:hover': { borderColor: '#64748B' },
                                                boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                                borderRadius: '0.375rem',
                                            }),
                                            singleValue: (base) => ({
                                                ...base,
                                                color: '#000000',
                                                fontSize: '0.875rem',
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                backgroundColor: state.isSelected ? '#cbd5e1' : state.isFocused ? '#cbd5e1' : 'white',
                                                color: '#000000',
                                                fontSize: '0.875rem',
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '0.875rem',
                                                color: '#A3AAB5',
                                            }),
                                        }}
                                    />
                                </div>

                                <div className="space-y-2">
                                    <label className="block text-sm font-medium text-gray-700">From Date:</label>
                                    <DateFilter
                                        onDateChange={handleDateChange}
                                        defaultFilterType={finalRange?.filterType}
                                    />
                                </div>


                                <div className="flex items-end h-full"
                                    onClick={resetData}
                                >
                                    <p className="font-medium mb-1 cursor-pointer bg-slate-300 text-black px-4 py-1.5 rounded-lg text-sm hover:bg-slate-400">
                                        Reset Filters
                                    </p>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="mt-3 bg-white p-4 border rounded-lg">
                        <p className='font-bold text-lg'>Escalations</p>
                        <Table
                            columns={columns}
                            data={data?.getSupportForCustomer?.data}
                            currentPage={page}
                            totalRecords={data?.getSupportForCustomer?.count || 0}
                            limit={limit}
                            setLimit={setLimit}
                            setPage={setPage}
                            loading={loading}
                            // deleteData={DeleteProduct}
                            // onSort={handleSort}
                            handlePagination={handlePagination}
                        // multiSelectRow={onSelectedRowsChange}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ViewTableEscalation
